import { ApiTags } from '@nestjs/swagger';
import { Controller, Post} from '@nestjs/common';
import {ApplicationExceptionHandler} from "packages/libs/backend-utils/src/"
import {  CommonResponseModel } from '@project-management-system/shared-models';
import { HsnCodeService } from './hsn-code.service';

@ApiTags('hsncode')
@Controller('hsncode')
export class HsnCodeController {
    constructor(
        private hsncodeService: HsnCodeService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}
   
  @Post('/getAllHsnCode')
  async getAllHsnCode(): Promise<CommonResponseModel> {
    try {
      return await this.hsncodeService.getAllHsnCode();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
    }
  }
}